// extracted by mini-css-extract-plugin
export default {"companies":"Companies_companies__-grTF","noMessage":"Companies_noMessage__fyyEH","delete":"Companies_delete__OfaZp","pagination":"Companies_pagination__MXTd0"};